import React, { PropsWithChildren, useEffect, useRef, useState } from 'react'

import { ReactComponent as CaretDownIcon } from '@app/assets/Small/Outline/CaretDown.svg'
import { bemJoin, classNames } from '@app/lib/bem'
import { Text } from '@app/lib/typography/Text/Text'
import './index.scss'

export type CollapsibleProps = {
  title: string
  expandedTitle?: string
  anchor?: 'top' | 'bottom'
  color?: 'primary' | 'neutral'
  size?: 'md' | 'lg'
  className?: string
}

export const Collapsible = ({
  title,
  expandedTitle,
  anchor = 'bottom',
  color = 'primary',
  size = 'md',
  className,
  children
}: PropsWithChildren<CollapsibleProps>) => {
  const b = bemJoin('collapsible')
  const [isExpanded, setIsExpanded] = useState(false)
  const [height, setHeight] = useState<number | undefined>(undefined)
  const contentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (contentRef?.current) {
      setHeight(contentRef.current.scrollHeight)
    }
  }, [contentRef, isExpanded])

  const handleToggle = () => {
    setIsExpanded(!isExpanded)
  }

  const currentHeight = isExpanded ? height : 0

  return (
    <div
      className={classNames(
        b({
          expanded: isExpanded,
          [anchor]: true,
          [color]: true
        }),
        className
      )}
    >
      <div style={{ height: currentHeight + 'px' }} className={b('body')} ref={contentRef}>
        {children}
      </div>
      <div className={b('trigger', { [size]: true })} onClick={handleToggle}>
        <Text size={size} color={color} className={b('title')}>
          {expandedTitle ? (isExpanded ? expandedTitle : title) : title}
        </Text>
        <CaretDownIcon
          className={b('icon', {
            expanded: isExpanded,
            [color]: true,
            [size]: true
          })}
        />
      </div>
    </div>
  )
}
